export default __webpack_public_path__ + "static/media/06.b4e3d106.png";